import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enTranslations from './locales/en.json';
import hrTranslations from './locales/hr.json';
import deTranslations from './locales/de.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  hr: {
    translation: hrTranslations,
  },
  de: {
    translation: deTranslations,
  },
};

const storedLanguage = localStorage.getItem('userLanguage') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: storedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    react: {
      useSuspense: false, // Set to false to avoid suspense issues
    },
  });

export default i18n; 